const SData = [
  {
    id: 1,
    image:
    "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720616690/WhatsApp_Image_2024-07-10_at_18.17.19_zi15hy.jpg",
    name: "Skand Tripathi",
    post: "Secretary",
    branch: "ECE",
    year: "Final",
    phone: "8090364218",
    fb: "",
    in: "https://www.linkedin.com/in/skand-tripathi-9935361ba/",
  },

  {
    id: 2,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720605288/WhatsApp_Image_2024-07-10_at_15.16.43_bky7oo.jpg",
    name: "Atul Mishra",
    post: "Joint Secretary",
    branch: "ECE",
    year: "Final",
    phone: "9839468684",
    fb: "",
    in: "https://www.linkedin.com/in/atul-mishra-754a601a5",
  },

  {
    id: 3,
    image:
    "https://res.cloudinary.com/dkddubkcn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1686848232/1681981391663_-_Chaitanya_Dubey_wzegfk.jpg",
    name: "Chaitanya Prakash Dubey",
    post: "Joint Secretary",
    branch: "EE",
    year: "Final",
    phone: "9628423580",
    fb: "",
    in: "https://www.linkedin.com/in/chaitanya-prakash-dubey/",
  },

  {
    id: 4,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720603368/WhatsApp_Image_2024-07-10_at_14.10.11_ol3nt0.jpg",
    name: "Ishika Gupta",
    post: "Joint Secretary",
    branch: "CSE",
    year: "Final",
    phone: "9569543653",
    fb: "",
    in: "https://www.linkedin.com/in/ishika-gupta-408b6a233/",
  },

  {
    id: 5,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720598895/IMG-20231022-WA0006_jkdjdi.jpg",
    name: "Kartikay Singh",
    post: "Joint Secretary",
    branch: "CSE",
    year: "Final",
    phone: "9569740697",
    fb: "",
    in: "https://www.linkedin.com/in/kartikay-singh-172899227/",
  },

  {
    id: 6,
    image:
    "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720605280/PXL_20231004_123639074_urrelj.jpg",
    name: "Priyansh Agarwal",
    post: "Joint Secretary",
    branch: "EE",
    year: "Final",
    phone: "8076245670",
    fb: "",
    in: "https://www.linkedin.com/in/priyanshag02/",
  },

  {
    id: 7,
    image:
    "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720616702/WhatsApp_Image_2024-07-10_at_18.31.20_1_r35vsi.jpg",
    name: "Satvik Tripathi",
    post: "Joint Secretary",
    branch: "ECE",
    year: "Final",
    phone: "9958494593",
    fb: "",
    in: "https://www.linkedin.com/in/satvik-tripathi-3b6579237/",
  },

  {
    id: 8,
    image:
    "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720605670/WhatsApp_Image_2024-07-10_at_09.55.10_1_vh8nci.jpg",
    name: "Parlakshit Tyagi",
    post: "T&P Final Year",
    branch: "CSE",
    year: "Final",
    phone: "9045111609",
    fb: "",
    in: "https://www.linkedin.com/in/parlakshit-tyagi-985175228/",
  },

  {
    id: 9,
    image:
    "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720591528/Harshit_Singh_fpjdnk.png",
  name: "Harshit Singh",
  post: "T&P Final Year",
  branch: "CSE",
  year: "Final",
  phone: "7398432919",
  fb: "",
  in: "https://www.linkedin.com/in/harshit-s-2b7319228/",
  },

  {
    id: 10,
    image:
    "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720591248/WhatsApp_Image_2024-07-10_at_09.58.01_r2j7rg.jpg",
    name: "Utkarsh",
  post: "T&P Final Year",
  branch: "CSE",
  year: "Final",
  phone: "7275682570",
  fb: "",
  in: "https://www.linkedin.com/in/utkarsh-kumar-saini-127a5022a/",
  },

  {
    id: 11,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720591553/Untitled_design_n9axsk.png",
    name: "Pratham Mishra",
    post: "T&P Final Year",
    branch: "IT",
    year: "Final",
    phone: "9682447792",
    fb: "",
    in: "https://www.linkedin.com/in/pratham-mishra-8476aa230/",
  },

  {
    id: 12,
    image:
      "https://res.cloudinary.com/dkddubkcn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1686848225/anant_kas8mg.jpg",
    name: "Anant Sharma",
    post: "T&P Final Year",
    branch: "IT",
    year: "Final",
    phone: "9305158703",
    fb: "",
    in: "https://www.linkedin.com/in/anant2310",
  },

  {
    id: 13,
    image:
      "https://res.cloudinary.com/dkddubkcn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1686848231/IMG-20221030-WA0008-01_-_Vansh_Yadav_ryfxkl.jpg",
    name: "Vansh Yadav",
    post: "T&P Final Year",
    branch: "ECE",
    year: "Final",
    phone: "9892053354",
    fb: "",
    in: "https://www.linkedin.com/in/vansh-yadav-30521a229/",
  },

  {
    id: 14,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720591491/WhatsApp_Image_2024-07-10_at_10.01.15_jirul8.jpg",
    name: "Pratyush Singh",
    post: "T&P Final Year",
    branch: "EE",
    year: "Final",
    phone: "6393075090",
    fb: "",
    in: "https://www.linkedin.com/in/pratyush-singh-5b37a9264/",
  },

  {
    id: 15,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720591015/WhatsApp_Image_2024-07-10_at_09.54.20_z50yot.jpg",
    name: "Ritika Agrahari",
    post: "T&P Final Year",
    branch: "EE",
    year: "Final",
    phone: "6387802506",
    fb: "",
    in: "https://www.linkedin.com/in/ritika-agrahari-938278230/",
  },

  {
    id: 16,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720591475/WhatsApp_Image_2024-07-10_at_09.59.04_sw8vaw.jpg",
    name: "Khushi Tiwari",
    post: "T&P Final Year",
    branch: "ME",
    year: "Final",
    phone: "9451911301",
    fb: "",
    in: "https://www.linkedin.com/in/khushi-tiwari-aa4302265/",
  },

  {
    id: 17,
    image:
      "https://res.cloudinary.com/dkddubkcn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1686848233/vanshika_qo6qha.jpg",
    name: "Vanshika Chaudhary",
    post: "T&P Final Year",
    branch: "CE",
    year: "Final",
    phone: "8081102044",
    fb: "",
    in: "https://www.linkedin.com/in/vanshika-chaudhary-532667235/",
  },
  {
    id: 18,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720591156/WhatsApp_Image_2024-07-10_at_09.57.42_h6ogdc.jpg",
    name: "Supriya Rai",
    post: "T&P Final Year",
    branch: "ChE",
    year: "Final",
    phone: "9936152574",
    fb: "",
    in: "https://www.linkedin.com/in/supriya-rai-503220248/",
  },
  {
    id: 19,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1721017462/WhatsApp_Image_2024-07-12_at_17.53.09_hotved.jpg",
    name: "Mridani Tripathi",
    post: "T&P Final Year",
    branch: "B.Pharma",
    year: "Final",
    phone: "6392937803",
    fb: "",
    in: "https://www.linkedin.com/in/mridani-tripathi-9533b925a/",
  },
  {
    id: 20,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720584421/Snapchat-569216250_-_Anjali_Shekhar_zi84a1.jpg",
    name: "Anjali Shekhar",
    post: "T&P Third Year",
    branch: "CSE",
    year: "Third",
    phone: "9336842883",
    fb: "",
    in: "https://www.linkedin.com/in/anjali-shekhar-814045258?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 21,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720617324/WhatsApp_Image_2024-07-10_at_16.17.39_da6ffv.jpg",
    name: "Nidhi Paswan",
    post: "T&P Third Year",
    branch: "CSE",
    year: "Third",
    phone: "6392217768",
    fb: "",
    in: "https://www.linkedin.com/in/nidhi-p-28354624a",
  },

  {
    id: 22,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720582882/IMG_0653_copy_-_Priyanshu_Tiwari_m0ohnn.jpg",
    name: "Priyanshu Tiwari",
    post: "T&P Third Year",
    branch: "CSE",
    year: "Third",
    phone: "9129606151",
    fb: "",
    in: "https://www.linkedin.com/in/priyanshu-tiwari-2522aa216?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 23,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720582827/20231022_172428_-_Nandita_Singh_wyyt8o.jpg",
    name: "Adamya Singh",
    post: "T&P Third Year",
    branch: "IT",
    year: "Third",
    phone: "9696504618",
    fb: "",
    in: "https://www.linkedin.com/in/adamyasingh19?trk=contact-info",
  },

  {
    id: 24,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720582887/Harsh_pic_-_Harsh_Upadhyay_mpgmxw.png",
    name: "Harsh Upadhyay",
    post: "T&P Third Year",
    branch: "ECE",
    year: "Third",
    phone: "8787073217",
    fb: "",
    in: "https://www.linkedin.com/in/harsh-upadhyay-46b99a247/",
  },

  {
    id: 25,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583877/IMG-20240513-WA0023_-_Pradeep_Tiwari_v9yxyu.jpg",
    name: "Pradeep Tiwari",
    post: "T&P Third Year",
    branch: "ECE",
    year: "Third",
    phone: "6393735559",
    fb: "",
    in: "https://www.linkedin.com/in/pradeep-tiwari-252632294/",
  },
  {
    id: 26,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720616973/WhatsApp_Image_2024-07-10_at_16.29.14_gq7idl.jpg",
    name: "Prashant Kushwaha",
    post: "T&P Third Year",
    branch: "ECE",
    year: "Third",
    phone: "8303195277",
    fb: "",
    in: "https://www.linkedin.com/in/prashantkush8854",
  },
  
  {
    id: 27,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720584605/TNP_ID_Card_photo_-_anonymous_w2hv2l.jpg",
    name: "Rajat Singh ",
    post: "T&P Third Year",
    branch: "ECE",
    year: "Third",
    phone: "8296404175",
    fb: "",
    in: "https://www.linkedin.com/in/rajat-singh-0a0529271?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 28,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720584552/Shrish_Narayan_omgbdf.jpg",
    name: "Shrish Narayan",
    post: "T&P Third Year",
    branch: "ECE",
    year: "Third",
    phone: "98423419238",
    fb: "",
    in: "https://www.linkedin.com/in/shrishnarayan073?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 29,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720605268/WhatsApp_Image_2024-07-10_at_10.08.55_mufkgh.jpg",
    name: "Abhiraj Gupta",
    post: "T&P Third Year",
    branch: "EE",
    year: "Third",
    phone: "8090285007",
    fb: "",
    in: "https://www.linkedin.com/in/abhiraj-gupta-01825921b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 30,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720603377/WhatsApp_Image_2024-07-10_at_14.46.51_o7wk0y.jpg",
    name: "Divyansh Maurya",
    post: "T&P Third Year",
    branch: "EE",
    year: "Third",
    phone: "7985734972",
    fb: "",
    in: "https://www.linkedin.com/in/divyansh-maurya-falcon?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 31,
    image:
      "https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583943/ld_1_-_Divyansh_Ojha_r9w0vh.jpg",
    name: "Divyansh Ojha",
    post: "T&P Third Year",
    branch: "EE",
    year: "Third",
    phone: "8707611688",
    fb: "",
    in: "https://www.linkedin.com/in/divyansh-ojha-6b9b27257?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 32,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720707301/WhatsApp_Image_2024-07-11_at_18.38.58_niygj6.jpg",
    name: "Ratnesh Pandey",
    post: "T&P Third Year",
    branch: "EE",
    year: "Third",
    phone: "8948691061",
    fb: "",
    in: "www.linkedin.com/in/ratnesh-pandey-38593b27b",
  },

  {
    id: 33,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583603/IMG_0656_copy_-_Shivansh_Tiwari_c8djga.jpg",
    name: "Shivansh Tiwari ",
    post: "T&P Third Year",
    branch: "EE",
    year: "Third",
    phone: "8429571263",
    fb: "",
    in: "https://www.linkedin.com/in/shivansh-tiwari-b82392249?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 34,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583922/IMG-20240514-WA0002_-_Aryansh_Bachchan_smczq4.jpg",
    name: "Aryansh Bachhan",
    post: "T&P Third Year",
    branch: "ME",
    year: "Third",
    phone: "9696478834",
    fb: "",
    in: "https://www.linkedin.com/in/aryansh-bachchan-548679275?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 35,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583855/IMG_20240512_104600_755_-_Sandesh_Chauhan_bhodco.jpg",
    name: "Sandesh Singh",
    post: "T&P Third Year",
    branch: "ME",
    year: "Third",
    phone: "9450245694",
    fb: "",
    in: "https://www.linkedin.com/in/sandesh-singh-1472ab271?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 36,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583850/IMG_20240512_080752_-_TNP_Students_iyznhr.jpg",
    name: "Archana Vishwakarma",
    post: "T&P Third Year",
    branch: "CHE",
    year: "Third",
    phone: "6388694030",
    fb: "",
    in: "https://www.linkedin.com/in/archana-vishwakarma-574992299?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

  {
    id: 37,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583618/IMG_20240512_001650_-_kanak_mishra_qo83ua.jpg",
    name: "Kanak Mishra",
    post: "T&P Third Year",
    branch: "CHE",
    year: "Third",
    phone: "9336435895",
    fb: "",
    in: "https://www.linkedin.com/in/kanak-mishra-05b270269?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    id: 38,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720708401/IMG_20240711_195939_vj68cf.jpg",
    name: "Aditi Upadhyay",
    post: "T&P Third Year",
    branch: "BBA",
    year: "Third",
    phone: "7905174604",
    fb: "",
    in: "https://www.linkedin.com/in/aditi-upadhyay-016312270?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    id: 39,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720582893/GridArt_20240513_223718462_-_Tanisha_Agrahari_y3gcjr.jpg",
    name: "Tanisha Agrahari",
    post: "T&P Third Year",
    branch: "BBA",
    year: "Third",
    phone: "6307134514",
    fb: "",
    in: "https://www.linkedin.com/in/tanisha-agrahari?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    id: 40,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720707723/WhatsApp_Image_2024-07-11_at_18.34.35_qiu5dp.jpg",
    name: "Akshara Srivastava",
    post: "T&P Third Year",
    branch: "B.Pharma",
    year: "Third",
    phone: "8960082005",
    fb: "",
    in: "https://www.linkedin.com/in/akshara-srivastava-929120294?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },  {
    id: 41,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583929/passportphoto_-_Tanmay_Mishra_swfmyu.jpg",
    name: "Tanmay Mishra",
    post: "T&P Third Year",
    branch: "MCA",
    year: "Final",
    phone: "8563960060",
    fb: "",
    in: "http://www.linkedin.com/in/tanmay-mishra-0a10171b2",
  },  {
    id: 42,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583513/img.tejash_-_Tejash_Shukla_k3k12w.jpg",
    name: "Tejas Shukla",
    post: "T&P Third Year",
    branch: "MCA",
    year: "Final",
    phone: "6387969277",
    fb: "",
    in: "https://www.linkedin.com/in/tejash-shukla-3b6953249?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },  {
    id: 43,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720583856/IMG_20240513_220531_918_-_ANKIT_VISHWAKARMA_cxev04.jpg",
    name: "Ankit Vishwakarma",
    post: "T&P Third Year",
    branch: "MBA",
    year: "Final",
    phone: "9565755796",
    fb: "",
    in: "https://www.linkedin.com/in/ankit-vishwakarma-881ba9218?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },  {
    id: 44,
    image:"https://res.cloudinary.com/da9ygbhjv/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1720584297/IMG_20240512_234731_415_-_Saurabh_Tyagi_lfzsey.jpg",
    name: "Saurabh Tyagi",
    post: "T&P Third Year",
    branch: "MBA",
    year: "Final",
    phone: "8077871057",
    fb: "",
    in: "https://www.linkedin.com/in/saurabh-tyagi-8b5941178?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
];

export default SData;
